<div>
    <app-header [title]="'myrewards.employee_summary' | translate" (onBackLinkClick)="goBack()" [backLinkText]="'myrewards.go_back' | translate" />

    <!-- Bounded container -->
    <div class="max-w-screen-xl mx-auto px-4 py-8 grid grid-cols-1 lg:grid-cols-12 gap-6 bg-gray-50">
        <!-- COL: Main (left, col-span-8 on desktop) -->

        <!-- Employee Summary -->
        <div class="bg-white p-4 col-span-12">

            <div class="overflow-auto">
                <app-table [class.with-pagination]="true" [data]="employeeSummaryData" [columns]="employeeSummaryColumns" [selectable]="false" [noDataMessage]="'myrewards.no_results_found' | translate"></app-table>
            </div>
            <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (onPageChange)="onPageChange($event)"> </app-pagination>
        </div>
    </div>
</div>
